import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ISortOption, ISortMainImage } from '../../models';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'lib-dropdown-filter-sorter',
  styleUrls: ['dropdown-filter-sorter.component.scss'],
  templateUrl: './dropdown-filter-sorter.component.html',
  imports: [FormsModule, ReactiveFormsModule, NgbDropdownModule],
})
export class DropdownFilterSorterComponent {
  @Input() name = 'filterdropdown';
  @Input() label: string;
  @Input() textClass: string;
  @Input() image!: ISortMainImage;
  @Input() list: ISortOption[] = [];
  @Input() activeValue: any;
  @Input() hideClearOption: boolean = true;
  @Input() ariaText: string;
  @Output() itemChange = new EventEmitter<ISortOption>();

  get active(): ISortOption | undefined {
    return this.list?.find((l) => l.value === this.activeValue);
  }

  trackByFn(index: any) {
    return index;
  }
}
